/**
* @title rxnewprescription.js: Sub-module for new prescription page
* @description This module is used to handle various new prescription related tasks
* @dependences 
*/
define(['rxaddresshelper'], function(rxAddressHelper) {
	
	var rxNewPrescription = {
		
		init : function(options) {
			if ($('#new-prescription-info').length == 1) {
				rxNewPrescription.populateStateSelectBox();
				rxNewPrescription.bindEvents();
				rxNewPrescription.maskInput();
			}
			rxNewPrescription.showHideShippingAndBillingSection();

			
			if (options != undefined) {
				rxAddressHelper.init(options);				
			}

		},
		/**
		 * show and hide billing and shipping section
		 */
		showHideShippingAndBillingSection: function() {

			$('#ship-when-ready').click(function() {
				$('#billing-and-shiping').show();
				if ($('#complete-prescription-request-button').attr('data-is-disabled-by-default') == 'true') {
					$('#complete-prescription-request-button').prop('disabled', true);
				}
			});
			
			$('#notify-when-ready').click(function() {
				$('#billing-and-shiping').hide();
				if ($('#complete-prescription-request-button').attr('data-is-disabled-by-default') == 'true') {
					$('#complete-prescription-request-button').prop('disabled', false);
				}
			});
		},
		/**
		 * Gets new prescription info form
		 * @return {form} New prescription info jquery form
		 */
		getForm: function() {
			return $('#NewPrescriptionForm');
		},
		
		/**
		 * Binding events
		 */
		bindEvents: function() {
			$('#new_prescription_next_button').click(function() {
				rxNewPrescription.proceedToNextPage();
			});
			$('#add-more-prescriptions-button').click(function() {
				COSTCO.rxPrescriptionHelper.drugSection.addMorePrescriptions('drug-info-block', 'single_drug_row');
			});
			
			$('body').on('hidden.bs.popover', function (e) {
		        $(e.target).data('bs.popover').inState.click = false;
		    });
		},
		
		/**
		 * Validates data on form and submits it.
		 */
		proceedToNextPage: function() {
			if(rxNewPrescription.validate()) {
				let form = rxNewPrescription.getForm();
				COSTCO.rxPrescriptionHelper.drugSection.setFilledPresciptionsCount();
				rxNewPrescription.getForm().submit();
			}
		},
		
		/**
		 * Populates state select field
		 */
		populateStateSelectBox: function() {
			let form = rxNewPrescription.getForm();
		    if (form.find('.state-select').length) {
		    	let stateProvList = this.getStateProvJson();
		        let stateOptions = this.getStateOptions(stateProvList);
		        form.find('.state-select').append(stateOptions);
		    }
		    let state_default = $('input[name=state_old]').val();
		    if(state_default != ""){
		    	form.find('.state-select').val(state_default);
			}
		},
		
	 	/**
	      * [description]
	      * @param  {[type]} stateProvList [description]
	      * @return {[type]}               [description]
	      */
	     getStateOptions: function(stateProvList) {
			return COSTCO.CAddressForm.getStateOptions(stateProvList);
	     },
	     /**
	      * [description]
	      * @return {[type]} [description]
	      */
	     getStateProvJson: function() {
	       return COSTCO.CAddress.getStateProvJson();
	     },
	     /**
	      * Uses Jquery Mask plugin to format input. Use cleanVal() instead of val()
	      * to get unformatted value
	      * @param  {[type]} template [description]
	      * @return {void}          [description]
	      */
	     maskInput: function() {
	    	 $('#NewPrescriptionForm').find('[name=physicianPhone]').unmask().mask('(000) 000-0000');
	     },
	     
	 	validationRulesApplied : false,
	 	
		/**
		 * Set of rules used for new prescription form validation
		 */ 
		validationRules : function() {

			if(!rxNewPrescription.validationRulesApplied){
		    	$.validator.addMethod("notEqual", function(value, element, param) {
					return this.optional(element) || value != param;
					}, messages.ERR_INVALID_STATE);
				$.validator.addMethod("physicianPhone", function( value, element ) {
					return this.optional(element) || /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/.test(value);
				}, messages.ERR_INVALID_PHONE1);
				/*Custom Validator to make sure at least one drug name (or Rx number por transfer) is entered*/
				$.validator.addMethod("require_from_group", 
						COSTCO.rxPrescriptionHelper.drugSection.drugNameValidationMethod, 
						messages.ERR_REQUIRED_DRUG_NAME);
				
				rxNewPrescription.validationRulesApplied = true;

			}
	    },
	     
	    /**
	     * Form validation
	     */
	    validate : function() {
	    	rxNewPrescription.validationRules();
	    	let form = rxNewPrescription.getForm();
			if (form.length != 0) {
				form.validate({
					focusInvalid : false,
					invalidHandler : COSTCO.util.invalid_handler,
					groups:{
		    			drugNames: COSTCO.rxPrescriptionHelper.drugSection.drugNames
					},
					rules : {
						physicianName : {required : true},
						physicianCity : {required : true},
						physicianState : {required: true, notEqual:"NO_STATE_TYPE_SELECTED"},
						physicianPhone : {required: true, physicianPhone:true},
						willMailPrescription: {required : true},
						drugName_0: {require_from_group: [1,'.drug-name']}
					},
					messages : {
						physicianName:	messages.ERR_REQUIRED_PHYSICIAN_NAME,
						physicianPhone: {required:messages.ERR_REQUIRED_PHYSICIAN_PHONE, physicianPhone:messages.ERR_INVALID_PHONE_NUMBER},
						physicianCity: messages.ERR_REQUIRED_PHYSICIAN_CITY,
						physicianState: messages.ERR_INVALID_STATE,
						willMailPrescription: messages.ERR_REQUIRED_ORIGINAL_PRESCRIPTION,
						drugName_0:	messages.ERR_REQUIRED_DRUG_NAME
					},
					errorPlacement: function(error, element) {
						
						if(element.hasClass('state-select')){
							error.appendTo(element);
							error.insertAfter($('[name=physicianState]').parent());
						}
						else if(element.hasClass('drug-name')){
							if(element.attr('name') === 'drugName_0') {
								error.appendTo(element.parent());
							}
						}
						//set error placement for radio button in newPrescription page
						else if (element.attr('type') === 'radio'){
							error.insertBefore($('#options-group'));
						}
						else {
							error.appendTo(element.parent());
						}
					}
				})

				let selectsValid = true;
				form.find('.style-select > select').each(function() {
					$(this).unbind('change').change(function(){
						if($(this).val()==="NO_STATE_TYPE_SELECTED"){
							selectsValid=false;
							$(this).parent().addClass('error');
						}else{
							$(this).parent().removeClass('error');
						}
					})
				});

				form.find('.style-select > select').change();
				return (form.valid() && selectsValid);
			}
		}
	}
	
	if (typeof window.COSTCO === "undefined") {
        window.COSTCO = new Object();
	} 
	
	window.COSTCO.rxNewPrescription = rxNewPrescription;
		
	return rxNewPrescription;
});


// WEBPACK FOOTER //
// ./js/rx/rxnewprescription.js